export default __webpack_public_path__ + "static/media/Regenwurm.12456819.png";